// @flow

import React, { Component } from 'react';
import styled from 'styled-components';

import BorderedIcon from "../../../components/BorderedIcon";
import ArrowRightIcon from '../../../components/Icons/ArrowRight';
import SettingsIcon from '../../../components/Icons/Settings';
import InviteIcon from '../../../components/Icons/Invite';

import colors from '../../../assets/css/colors';
import IconLinkStyled, { IconLinkGroup } from './IconLinkStyled';
import LeagueStatusLabel from './LeagueStatusLabel';

import LeagueBase from './LeagueBase';
import getLinkStates from './getLinkStates';

const LeagueStatusLabelStyled = styled(LeagueStatusLabel)`
	text-align: center;
	margin-right: 40px;
`;

type Props = {
	league: Object,
	is_commissioner: boolean
};

class UnscheduledLeague extends Component<Props> {
	renderRightSide = () => {
		const { league, is_commissioner } = this.props;
		const links = getLinkStates(league, is_commissioner);

		return (
			<React.Fragment>
				<LeagueStatusLabelStyled>Unscheduled League</LeagueStatusLabelStyled>

				<IconLinkGroup>
					{links.invite ? (
						<IconLinkStyled to={links.invite} title="Invite">
							<BorderedIcon hover={colors.lightGreen}>
								<InviteIcon
									cursor="pointer"
									size="1.875"
									color={colors.nrlDarkGreen}
								/>
							</BorderedIcon>
						</IconLinkStyled>
					) : null}

					<IconLinkStyled to={links.settings} title="Settings">
						<BorderedIcon hover={colors.lightGreen}>
							<SettingsIcon
								cursor="pointer"
								size="1.875"
								color={colors.nrlDarkGreen}
							/>
						</BorderedIcon>
					</IconLinkStyled>

					<IconLinkStyled to={links.arrow} title="Go to League">
						<BorderedIcon hover={colors.lightGreen}>
							<ArrowRightIcon
								cursor="pointer"
								size="1.875"
								color={colors.nrlDarkGreen}
							/>
						</BorderedIcon>
					</IconLinkStyled>
				</IconLinkGroup>
			</React.Fragment>
		);
	}

	render() {
		const { league, is_commissioner } = this.props;

		return (
			<LeagueBase
				league={league}
				is_commissioner={is_commissioner}
				show_teams_count
				background="transparent"
				renderRightSide={this.renderRightSide}
			/>
		);
	}
}

export default UnscheduledLeague;


// WEBPACK FOOTER //
// ./src/pages/leagues/myLeagues/UnscheduledLeague.js